module.exports = __webpack_public_path__ + "img/new1.2e03b0e1.png";